import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
  standalone: true,
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(blob: Blob | null | undefined): SafeResourceUrl | null {
    if (!blob || !(blob instanceof Blob)) {
      console.error('SafeUrlPipe: Valor fornecido não é um Blob válido.', blob);
      return null; // Retorna null se o valor não for um Blob
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
  }
}
